import React from 'react';
import Layout from '../../components/Layout/Layout';
import Button from '../../components/UI/Button/index';
import { useUser, useUserDispatchers } from '../../state/user';
import css from './ParentInvite.module.scss';

type ParentInviteWithPhoneNumberProps = {
  onParentInvite: () => void;
};
const ParentInviteWithPhoneNumber = (
  props: ParentInviteWithPhoneNumberProps
) => {
  const { setNextRegStep } = useUserDispatchers();
  const { userIsTeen } = useUser();

  const header = 'Invite your parent to get a Greenlight card';
  const subHeader =
    'You’ll need a parent or guardian to set up a Greenlight debit card. Send an invite link to them.';

  const onSendInviteLinkClick = async () => {
    try {
      props.onParentInvite();
      await navigator.share({
        title: 'Debit Card for Kids and Teens | Greenlight',
        url: 'https://greenlight.onelink.me/W7Wd/bkkqmovy',
        text: 'Your child invited you to join Greenlight, the money app and debit card for kids and teens. Send your child money instantly, assign chores, and teach them to earn, save, and invest. '
      });
      setNextRegStep(userIsTeen ? 'validate' : 'parent_invite_complete');
    } catch (e) {
      console.log('user cancelled share action');
    }
  };

  return (
    <Layout data-e2e="parent-invite-container">
      <div className={css.ParentInviteMainBox} data-e2e="need-adult">
        <h1 data-e2e="need-adult-header">{header}</h1>
        <p data-e2e="need-adult-legal">{subHeader}</p>
      </div>
      <div className={css.CtasContainer}>
        <Button text="Send invite link" onClick={onSendInviteLinkClick} />
      </div>
    </Layout>
  );
};

export default ParentInviteWithPhoneNumber;
